import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Deportes", -1)
const _hoisted_2 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-5 g-4" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSports, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col"
        }, [
          _createVNode(_component_router_link, {
            to: `${item.slug}/teams`,
            class: "card mb-8 shadow text-black border border-2 border-primary border-hover text-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.logo,
                class: "card-img-top",
                alt: item.name
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, [
                  _createTextVNode(_toDisplayString(item.name), 1),
                  _hoisted_6,
                  _createTextVNode(" (" + _toDisplayString(item.acronym) + ")", 1)
                ]),
                _createVNode(_component_router_link, {
                  to: `${item.slug}/teams`,
                  class: "btn btn-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ingresar")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ], 64))
}